import React from 'react';

import './Auth.styles.css';
import { getApiUrl } from '../../utils/apiUrls';
import ProgressBar from '../../components/progress-bar/ProgressBar.component';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { apiErrorHandler } from '../../utils/errorHandler';
import { openSnackBar } from '../../redux/actions/snackbar.actions';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import MetaComp from '../../components/meta-comp/MetaComp.component';

const ActivateAccountPage = () => {
    const [searchParams] = useSearchParams();
    const getId = searchParams.get('id');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const getLang = searchParams.get('lang');
    const getRefId = searchParams.get('refId');

    const { t } = useTranslation();

    const activateAccount = async (id) => {
        try {
            const res = await axios.get(`${getApiUrl('activate_account')}?id=${id}${getRefId ? `&refId=${getRefId}` : ''}`);

            if(res.data.status === "SUCCESS") {
                dispatch(openSnackBar({
                    msg: t(res.data.message),
                    type: 'success'
                }))

                navigate(`/login${!!getLang ? `?lang=${getLang}` : ''}${getRefId ? `${getLang ? '&' : '?'}refId=${getRefId}` : ''}`, { replace: true })
            }

        } catch (err) {
            const errObj = apiErrorHandler(err);

            dispatch(openSnackBar({
                msg: t(errObj.statusText),
                type: 'error'
            }))

            setTimeout(() => {
                if(errObj.statusText === "this_profile_already_exists" || errObj.statusText === "unable_to_find_this_profile" || errObj.statusText === "link_expired_please_request_a_new_Link") {
                    navigate(`/login${!!getLang ? `?lang=${getLang}` : ''}${getRefId ? `${getLang ? '&' : '?'}refId=${getRefId}` : ''}`, { replace: true })
                }
            }, 2000)
        }
    }

    React.useEffect(() => {
        if(!!getId) {
            activateAccount(getId)
        }
    }, [t])

    return(
        <main className='cm-page-container cm-auth-page-container d-flex row mx-0 d-flex align-items-center justify-content-center'>
            <MetaComp title={t("activate_account_page_title")} />
            <ProgressBar />
        </main>
    )

}

export default ActivateAccountPage;